import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type PaymentMethods {\n    name: String\n    payment_method_id: Int\n    payment_method_type_name: String\n  }\n\n  type Query {\n    paymentMethods: [PaymentMethods]\n  }\n"])));
export var resolvers = {
  Query: {
    paymentMethods: function () {
      var _paymentMethods = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _args, _ref) {
        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataSources = _ref.dataSources;
                _context.next = 3;
                return dataSources.paymentMethods.paymentMethods();

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res.payment_methods);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function paymentMethods(_x, _x2, _x3) {
        return _paymentMethods.apply(this, arguments);
      }

      return paymentMethods;
    }()
  }
};